import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const crmNavigation: ModuleNavigation = [
  {
    title: 'CRM',
    items: [
      { path: '/crm/dashboard', label: 'Dashboard' },
      { path: '/crm/pipeline', label: 'Pipeline' },
      { path: '/crm/companies', label: 'Companies' },
    ],
  },
];
